import React, { useState, useEffect } from 'react';
import { toolkitStore } from '../../Product-Toolkits';
import { styled, lighten } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import './Header.scss';
import IQumulateAgentValidation from '../../../../../../components/IQumulateAgentValidation/IQumulateAgentValidation';

const HeaderDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})`
  &.primary {
    background-color: ${(props) => (props.bgColor ? props.bgColor : 'transparent')};
  }

  &.secondary {
    background-color: ${(props) => (props.bgColor ? lighten(props.bgColor, 0.8) : 'transparent')};
  }

  &.tertiary {
    background-color: ${(props) => (props.bgColor ? lighten(props.bgColor, 0.8) : 'transparent')};
  }
`;

const additionalHeaderDetails = {
  term: {
    number: '(888) 996-3775',
    hours: {
      range1: {
        dow: 'MON-THR',
        starttime: {
          digit: '10',
          meridium: 'AM',
        },
        endtime: {
          digit: '7:30',
          meridium: 'PM',
        },
      },
      range2: {
        dow: 'FRI',
        starttime: {
          digit: '9',
          meridium: 'AM',
        },
        endtime: {
          digit: '6',
          meridium: 'PM',
        },
      },
    },
  },
};

const additionalHeaderDetailsINSpeedNow = {
  term: {
    number: '(888) 996-3775',
    hours: {
      range1: {
        dow: 'MON-THR',
        starttime: {
          digit: '10',
          meridium: 'AM',
        },
        endtime: {
          digit: '7:30',
          meridium: 'PM',
        },
      },
      range2: {
        dow: 'FRI',
        starttime: {
          digit: '9',
          meridium: 'AM',
        },
        endtime: {
          digit: '6',
          meridium: 'PM',
        },
      },
    },
  },
};

function Header(props) {
  const productIndex = toolkitStore((state) => state.productIndex);

  useEffect(() => {}, []);

  return (
    <>
      {props.productDetails === undefined ? (
        <>
          <LoadingSkeleton />
        </>
      ) : (
        <div className="header-wrapper">
          <HeaderDiv
            bgColor={props.productDetails[productIndex].BaseColorCss}
            className="primary toolkit-content"
            id="toolkitheader-image"
          >
            {props.productDetails.length === 1 ? (
              <div className="d-flex align-items-center justify-content-center">
                <img
                  src={props.productDetails[0].ImageBase64.replace('ProductImages', 'CmsImages')}
                />
              </div>
            ) : (
              <ProductImageSwitch
                image1={props.productDetails[0].ImageBase64}
                image2={props.productDetails[1].ImageBase64}
                title1={props.productDetails[0].Title}
                title2={props.productDetails[1].Title}
                uw1={props.productDetails[0].Underwritten}
                uw2={props.productDetails[1].Underwritten}
                faceAmounts1={props.productDetails[0].FaceAmounts}
                faceAmounts2={props.productDetails[1].FaceAmounts}
              />
            )}
          </HeaderDiv>
          <HeaderDiv
            bgColor={props.productDetails[productIndex].BaseColorCss}
            className="secondary toolkit-content"
            id="toolkit-title"
          >
            <ProductTitle
              title={props.productDetails[productIndex].Title}
              underwritten={props.productDetails[productIndex].Underwritten}
              faceAmounts={props.productDetails[productIndex].FaceAmounts}
              productId={props.productDetails[productIndex].ProductId}
              apptInfo={props.apptInfo}
              licInfo={props.licInfo}
            />
          </HeaderDiv>
          <HeaderDiv
            bgColor={props.productDetails[productIndex].BaseColorCss}
            className="tertiary toolkit-content"
            id="toolkit-details"
          >
            {/*Don't show contact information for iProvide Whole Life*/}
            {props.productDetails[productIndex].ID != 18 && (
              <AdditionalDetails productID={props.productDetails[productIndex].ProductId} />
            )}
          </HeaderDiv>
        </div>
      )}
    </>
  );
}

function ProductImageSwitch(props) {
  const setProductIndex = toolkitStore((state) => state.setProductIndex);
  const productIndex = toolkitStore((state) => state.productIndex);

  return (
    <div className="image-switch-wrapper">
      <div
        className={'image-switch text-center ' + (productIndex === 0 ? 'active' : '')}
        onClick={() => setProductIndex(0)}
      >
        <div className="product-title">
          <div>{props.title1}</div>
        </div>
        <div className="product-image">
          <img src={props.image1} />
        </div>
      </div>
      <div
        className={'image-switch text-center ' + (productIndex === 1 ? 'active' : '')}
        onClick={() => setProductIndex(1)}
      >
        <div className="product-title">
          <div>{props.title2}</div>
        </div>
        <div className="product-image">
          <img src={props.image2} />
        </div>
      </div>
    </div>
  );
}

function ProductTitle(props) {
  return (
    <div className="d-flex flex-column align-items-center text-center">
      <h1>{props.title}</h1>
      <h3>{props.underwritten}</h3>
      <h6>{props.faceAmounts}</h6>
      {/*BL-4178 - Removed the MYGA requirement, all products use this widget ( except brokerage ) */}
      {/*BL-4611 - Passing in Appt Info and License Info*/}
      {<IQumulateAgentValidation productID={props.productId} />}
    </div>
  );
}

{
  /*To-Do: Remember to change ".term." to ".{product}." if pos call center hours differ per product*/
}
{
  /*Make a little more dynamic on the hours rendering. Loop through ranges instead of hard-coding */
}

function AdditionalDetails(props) {
  let headerDetails = additionalHeaderDetails;

  switch (props.productID) {
    case 'UL':
    case 'WL':
    case 'LT':
    case 'SGSL':
      headerDetails = additionalHeaderDetailsINSpeedNow;
      break;
    default:
      headerDetails = additionalHeaderDetails;
      break;
  }

  return (
    <>
      <div className="row text-center">
        <div className="col-12">
          <div className="row" id="pos-title-info">
            {props.productID === 'MYGA' && (
              <div className="col-12">
                <div className="row" id="pos-title" style={{ fontSize: '1.4em' }}>
                  <div className="col-12">
                    <b>Annuity Services Support Center</b>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12" id="pos-number">
                    <b>(877) 533-2468</b>
                  </div>
                </div>
              </div>
            )}
            {props.productID !== 'MYGA' && (
              <div className="col-12">
                <div className="row" id="pos-title">
                  <div className="col-12">
                    <b>Point-of-Sales Underwriting Decision Call Center</b>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12" id="pos-number">
                    <b>Client Interviews: </b>
                    {headerDetails.term.number}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="row" id="dow-hours-wrapper">
            <div className="col-12">
              <div className="row">
                <div className="col-12" id="hours-divider-text">
                  <br />
                  <b>HOURS</b>
                  <br />
                </div>
              </div>
              {props.productID === 'MYGA' && <div>Hours: 9:00 a.m. - 5:00 p.m. Eastern Time</div>}
              {props.productID !== 'MYGA' && (
                <div className="row" id="dow-hours">
                  <div className="col-6" id="hour-1">
                    <div className="row hours">
                      <div className="col-12">
                        <b>{headerDetails.term.hours.range1.starttime.digit}</b>
                        <sup>
                          <b>{headerDetails.term.hours.range1.starttime.meridium}</b>
                        </sup>
                        <b> - </b>
                        <b>{headerDetails.term.hours.range1.endtime.digit}</b>
                        <sup>
                          <b>{headerDetails.term.hours.range1.endtime.meridium}</b>
                        </sup>
                      </div>
                    </div>
                    <div className="row dow">
                      <div className="col-12">
                        <b>{headerDetails.term.hours.range1.dow}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-6" id="hour-2">
                    <div className="row hours">
                      <div className="col-12">
                        <b>{headerDetails.term.hours.range2.starttime.digit}</b>
                        <sup>
                          <b>{headerDetails.term.hours.range2.starttime.meridium}</b>
                        </sup>
                        <b> - </b>
                        <b>{headerDetails.term.hours.range2.endtime.digit}</b>
                        <sup>
                          <b>{headerDetails.term.hours.range2.endtime.meridium}</b>
                        </sup>
                      </div>
                    </div>
                    <div className="row dow">
                      <div className="col-12">
                        <b>{headerDetails.term.hours.range2.dow}</b>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function LoadingSkeleton(props) {
  return (
    <>
      <div className="row ml-0 mr-0">
        <div className="col-12 col-md-12 col-lg-2">
          <Skeleton variant="rectangular" height={'15em'} width={1000} />
        </div>
        <div className="col-12 col-md-6 col-lg-5">
          <Skeleton variant="rectangular" height={'15em'} width={1000} />
        </div>
        <div className="col-12 col-md-6 col-lg-5">
          <Skeleton variant="rectangular" height={'15em'} width={1000} />
        </div>
      </div>
    </>
  );
}

export { Header };
